<template>
  <van-field :label="label" :value="value" readonly size="large" />
  <!-- :highlight="highlight"
    :class="{ highlight }" -->
</template>
<script>
export default {
  props: {
    label: [String],
    value: [String],
    // highlight: [Boolean],
  },
};
</script>
<style lang="less" scoped>
// .highlight /deep/.van-field__control {
//   color: #faad14;
// }
</style>
